import { ChangeEvent } from 'react';
import { MenuItem, TextField } from '@material-ui/core';
import { IconInfoCircle } from '@tabler/icons';

import { DocumentType, DocumentTypeValue } from '#root/models/Shipping';
import { validateDocNumber } from '#root/utils';
import styles from './addressDocumentFields.module.scss';

export interface AddressDocumentValue {
  docType: DocumentTypeValue;
  docNumber: string;
}

interface AddressDocumentFieldsProps extends AddressDocumentValue {
  onChange: (value: AddressDocumentValue) => void;
  disabled?: boolean;
}

/**
 * Documento de quien recibe en una dirección (DNI o CE).
 * Controlado: el padre guarda el valor y decide cuándo enviarlo. Incluye el texto que lo
 * distingue del documento de la cuenta.
 */
const AddressDocumentFields = (props: AddressDocumentFieldsProps) => {
  const { docType, docNumber, onChange, disabled = false } = props;
  const docError = validateDocNumber(docType, docNumber);

  const handleDocTypeChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange({ docType: event.target.value as DocumentTypeValue, docNumber });
  };

  const handleDocNumberChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    // Solo dígitos
    if (value === '' || /^\d+$/.test(value)) {
      onChange({ docType, docNumber: value });
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.documentRow}>
        <TextField
          select
          required
          variant="outlined"
          label="Tipo Doc."
          value={docType}
          onChange={handleDocTypeChange}
          disabled={disabled}>
          <MenuItem value={DocumentType.dni}>DNI</MenuItem>
          <MenuItem value={DocumentType.ce}>CE</MenuItem>
        </TextField>
        <TextField
          required
          variant="outlined"
          label="Número de documento"
          placeholder={docType === DocumentType.dni ? '12345678' : '123456789'}
          value={docNumber}
          onChange={handleDocNumberChange}
          error={!!docError}
          helperText={docError}
          disabled={disabled}
          inputProps={{
            maxLength: docType === DocumentType.dni ? 8 : 12,
            inputMode: 'numeric',
          }}
        />
      </div>
      <div className={styles.note}>
        <IconInfoCircle size={16} />
        <span>
          Este documento se asocia a esta dirección (de quien recibe el paquete). No es el documento
          de tu cuenta Guvery.
        </span>
      </div>
    </div>
  );
};

export default AddressDocumentFields;
